import { useContext } from 'react';
import { AppContext } from '../../context';

const PageTransition = () => {
    const { activeSkinConfig } = useContext(AppContext);
    return (
        <div
            className='d-flex justify-content-center align-items-center'
            style={{
                width: '80%',
                height: '100vh',
                textAlign: 'center',
                margin: 'auto',
            }}
        >
            <img
                src={`./assets/images/transitions/${activeSkinConfig.pageTransitionClass}.gif`}
                alt='Transition_SmartAccess'
                style={{
                    width: '80%',
                    height: '100%',
                    textAlign: 'center',
                }}
            />
        </div>
    );
};
export default PageTransition;
